const view = /* html */ `
<!--begin::Page-->
<div class="page d-flex flex-row flex-column-fluid">   
     <!--begin::Aside-->
     <div id="kt_aside" class="aside pb-5 pt-5 pt-lg-0" data-kt-drawer="true" data-kt-drawer-name="aside" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'80px', '300px': '100px'}" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_aside_mobile_toggle"></div>
     <!--end::Aside-->
    <!--begin::Wrapper-->
    <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <!--begin::Header-->
        <div id="kt_header" ${window.isMobile ? `style="background-image: url('assets/media/logos/header.png')"`: ""} class="header align-items-stretch"></div>
        <!--end::Header-->

        <!--begin::Toolbar-->
        <div class="toolbar py-2" id="kt_toolbar"></div>
        <!--end::Toolbar-->

        <!--begin::Content-->
        <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
        </div>
        <!--end::Content-->

        <!--begin::Footer-->
        <div class="footer py-4 d-flex flex-lg-column" id="kt_footer" style="background-color:#151515">
        </div>
        <!--end::Footer-->
    </div>
    <!--end::Wrapper-->    
</div>
<!--end::Page-->`;

export default view;